import * as ng from 'angular';

import {ReportTableFactory, ReportTableService, Dataset, DatasetField} from '.';

export class ReportTableController {
   static $inject = ['reportTableFactory', 'loader'];

   constructor(private reportTableFactory:ReportTableFactory, private loader) { }

   dataset:Dataset;
   filter:{};
   grid:ReportTableService;

   $onInit() {
      this.grid = this.reportTableFactory({ds: this.dataset});
      if (this.filter) {
         this.load();
      }
   }

   $onChanges(onChangesObj:ng.IOnChangesObject) {
      if (onChangesObj.filter.currentValue) {
         this.load();
      }
   }

   rowClick(row) {
      if (this.grid.isGrouped && row.isExpandable) {
         this.grid.expandRow(row);
      }
   }

   sortBy(field:DatasetField, order:string) {
      this.loader.showSpinner();
      this.grid.sortBy(field, order).finally(() => {
         this.loader.hide();
      });
   }

   removeSort(field:DatasetField) {
      this.loader.showSpinner();
      this.grid.removeSort(field).finally(() => {
         this.loader.hide();
      });
   }

   load() {
      if (!this.grid) {
         return;
      }

      this.loader.showSpinner();

      return this.grid.load(this.filter).finally(() => {
         this.loader.hide();
      });
   }
}

ng.module('e360').component('reportTable', {
   templateUrl: require('./report-table.html'),
   controller: ReportTableController,
   bindings: {
      dataset: '<datasource',
      filter: '<'
   }
});
